import { Controller } from "@hotwired/stimulus";

export default class NavbarController extends Controller {
  lastScroll = 0;

  connect() {
    document.addEventListener("scroll", this.onWindowScroll.bind(this));
  }

  disconnect() {
    document.removeEventListener("scroll", this.onWindowScroll.bind(this));
  }

  onWindowScroll() {
    const currentScroll = window.scrollY;
    const scrollThreshold = window.innerHeight / 8;
    const maxScroll = document.body.scrollHeight - window.innerHeight;

    const isNeedToHide = currentScroll > scrollThreshold;
    const isScrollingDown = currentScroll >= this.lastScroll;
    const isOverScroll = maxScroll !== 0 && currentScroll >= maxScroll;

    if (isNeedToHide && (isScrollingDown || isOverScroll)) {
      // Скроллинг вниз
      this.element.classList.remove("nav-visible");
      this.element.classList.add("nav-hidden");
    } else {
      // Скроллинг вверх
      this.element.classList.remove("nav-hidden");
      this.element.classList.add("nav-visible");
    }

    this.lastScroll = currentScroll;
  }
}
